/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { registryDiscoveryDiscoverServers } from "../funcs/registryDiscoveryDiscoverServers.js";
import { registryDiscoveryDiscoverVersion } from "../funcs/registryDiscoveryDiscoverVersion.js";
import { registryDiscoveryDiscoverVersions } from "../funcs/registryDiscoveryDiscoverVersions.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { RegistryDiscoveryPage } from "../models/components/registrydiscoverypage.js";
import {
  DiscoverServersRequest,
  DiscoverServersSecurity,
} from "../models/operations/discoverservers.js";
import {
  DiscoverVersionRequest,
  DiscoverVersionSecurity,
} from "../models/operations/discoverversion.js";
import {
  DiscoverVersionsRequest,
  DiscoverVersionsSecurity,
} from "../models/operations/discoverversions.js";
import { unwrapAsync } from "../types/fp.js";

export class RegistryDiscovery extends ClientSDK {
  /**
   * discoverServers registryDiscovery
   */
  async discoverServers(
    security: DiscoverServersSecurity,
    request?: DiscoverServersRequest | undefined,
    options?: RequestOptions,
  ): Promise<RegistryDiscoveryPage> {
    return unwrapAsync(registryDiscoveryDiscoverServers(
      this,
      security,
      request,
      options,
    ));
  }

  /**
   * discoverVersions registryDiscovery
   */
  async discoverVersions(
    security: DiscoverVersionsSecurity,
    request: DiscoverVersionsRequest,
    options?: RequestOptions,
  ): Promise<RegistryDiscoveryPage> {
    return unwrapAsync(registryDiscoveryDiscoverVersions(
      this,
      security,
      request,
      options,
    ));
  }

  /**
   * discoverVersion registryDiscovery
   */
  async discoverVersion(
    security: DiscoverVersionSecurity,
    request: DiscoverVersionRequest,
    options?: RequestOptions,
  ): Promise<any> {
    return unwrapAsync(registryDiscoveryDiscoverVersion(
      this,
      security,
      request,
      options,
    ));
  }
}
